import * as vp from 'vopay';

type VerificationRows = {
  id: vp.VerificationId;
  preset: keyof vp.TextFieldPresets;
  placeholder?: string;
};

export const buildVerificationRows = (): VerificationRows[] => [
  {
    id: vp.VerificationId.Amount1,
    preset: 'text',
    placeholder: '0',
  },
  {
    id: vp.VerificationId.Amount2,
    preset: 'text',
    placeholder: '0',
  },
];
